import { Button, Grid } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'

const retornaPrograma = (u = []) => ({
  idTipoUsuario: u[0],
  dsTipoUsuario: u[1],
  tpUsuario: u[2],
})

const Edicao = ({ programaAberto, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', {
      ...values,
      dsIcone: values.dsIcone?.icone || '',
    })
    if (res.status) voltar()
    else alert(res.dsErro)
  }

  return (
    <Formik
      initialValues={retornaPrograma(programaAberto)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <Field
                component={TextField}
                name="dsTipoUsuario"
                label="Description"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <Field
                component={TextField}
                name="tpUsuario"
                label="Type"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Save
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
